import { render, staticRenderFns } from "./demandPublishForm.vue?vue&type=template&id=25e5e876&scoped=true&"
import script from "./demandPublishForm.vue?vue&type=script&lang=js&"
export * from "./demandPublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5e876",
  null
  
)

export default component.exports